/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Images
import map from '../../assets/images/map.svg';

function Location() {
    return (
        <section className="locations py-28 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5">
            <div className="header mb-24">
                <h1 className="text-gray-100 text-center text-3xl font-semibold mb-4">Global Locations</h1>
                <p className="text-gray-300 text-center">We have multiple Data Centers Worldwide to choose from.</p>
            </div>
            <div className="body">
                <img src={map} alt="Location Map" className="block mx-auto" />
            </div>
        </section>
    )
}

export default Location